module.exports = __webpack_public_path__ + "static/media/virus.d548abdf.png";